<template>
<div v-if="banner" :class="`main-ban-container main-ban-container--${uuid}`">
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div v-for="(slide, index) in banner.slides.filter(slide => slide.image)" :key="index" class="swiper-slide">
                <picture>
                    <!-- 모바일 이미지-->
                    <source :srcset="slide.image" media="(max-width:768px)">
                    <!-- PC 이미지 -->
                    <img :src="slide.image" alt="">
                </picture>
            </div>
        </div>
    </div>
    <div class="slide-pagination"></div>
</div>
</template>

<script>
import api from "@/api";

let uuid = 0;
export default {
    props: {
        code: { type: String, default: null }
    },
    data() {
        return {
            uuid,
            banner: null,
        }
    },
    beforeCreate() {
        uuid += 1;
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try{
                var { banner } = await api.v1.banners.getBanner({ code: this.$props.code });
                this.banner = banner;
                this.$nextTick(() => {
                    this.render();
                });
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        render(){
            var slideBannerLeft = new Swiper(`.main-ban-container--${this.uuid} .swiper-container`, {
                allowTouchMove: true,
                spaceBetween: 0,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: true,
                    disableOnInteraction: false,
                },
                slidesPerView: 1,
                slidesPerGroup: 1,
                speed: 300,
                loop: true,
                pagination: {
                    el: `.main-ban-container--${this.uuid} .slide-pagination`,
                    clickable: true,
                },
            });
        }
    },
}
</script>
